export enum BreedingOrderStatus {
    Unknown,
    Pending,
    Executed,
    Cancelled
}